var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    _vm._l(_vm.reports, function(report, i) {
      return _c(
        "b-col",
        { key: i, attrs: { cols: "12", md: "6" } },
        [
          _c(
            "b-card",
            { staticClass: "mb-2" },
            [
              _c("b-card-title", {
                staticClass: "report-title",
                domProps: { innerHTML: _vm._s(report.Description) }
              }),
              _vm._v(" "),
              report.GadgetType === "1"
                ? _c(
                    "div",
                    { staticClass: "report-box" },
                    [_c("Chart", { attrs: { RecordId: report.RecordId } })],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              report.GadgetType === "4"
                ? _c(
                    "div",
                    { staticClass: "report-box" },
                    [_c("Chart", { attrs: { RecordId: report.RecordId } })],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              report.GadgetType === "2"
                ? _c(
                    "div",
                    { staticClass: "report-box" },
                    [_c("Grid", { attrs: { RecordId: report.RecordId } })],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              report.GadgetType === "3"
                ? _c(
                    "div",
                    { staticClass: "report-box" },
                    [
                      _c("TextReport", { attrs: { RecordId: report.RecordId } })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7625fe4f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7625fe4f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/TabContent.vue
// module id = null
// module chunks = 